<!-- 主页的导航 -->
<template>
	<div class="bar-box">
		<bv-tab-bar v-if="list" :list="list" :active-class-name="'bc-t-blue'"  :active-index="activeIndex" style="box-shadow: 0 4px 18px rgba(0,0,0,0.1) !important;"></bv-tab-bar>
	</div>
</template>

<script>

  import store from '@store';
  import homeTabBer from './home-tab-bar';

  export default {
    name: "w-tab-bar",
    data() {
      return {
        activeIndex: 1,
        allTabBar: {
          'home': homeTabBer
        }
      }
    },
    computed: {
      tabBarName() {
        return store.state.view.tabBar;
      },
      list() {
        const currentNav = this.allTabBar[this.tabBarName];
        return currentNav && currentNav.list.items;
      }
    },
    watch: {
      ['$route']() {
        this.activeNav();
      }
    },
    methods: {
      activeNav() {
        //匹配到对应导航配置
        const nav = this.allTabBar[this.tabBarName];
        if (nav) {
          nav.active.call(this);
        } else if (this.tabBarName !== false) {
          //没有配置到导航配置，直接设置为没有导航
          store.commit('setTabBar', false);
        }
      }
    },
    mounted() {
      this.activeNav();
    }
  }
</script>

<style scoped lang="scss">
	.bv-tab-bar {
		border: none !important;
	}
	
	.bar-box /deep/ .bv-tab-bar-item:nth-child(1) {
		border-right: 1px solid #eee;
	}
	
	.bar-box /deep/ #tabBar {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.bar-box /deep/ .bv-tab-bar-list-container {
		flex: 1;
	}
	/deep/ .bc-t-blue{
		color:#D7211E;
	}
</style>
